export const SAMARITANS_PHONE_NUMBER = "116123";
